module.exports = __webpack_public_path__ + "static/media/01B.f8edc5ff.png";